import * as Yup from 'yup'

import { AccountType } from 'src/types/account'

import { accountTypeValidationSchema } from './AccountFormFieldSets/validationSchema'
import { AccountActionType } from './types'

export const validationSchema = Yup.object({
  ...accountTypeValidationSchema('AccountType'),
  AccountActionType: Yup.string()
    .oneOf(Object.values(AccountActionType))
    .required('Please select your action type'),
  AccountType: Yup.string().required('Please select an account type'),
  Avatar: Yup.string().required(),
  AvatarFile: Yup.array(),
  Banner: Yup.string().required(),
  BannerFile: Yup.array(),
  FirstName: Yup.string().required('First name is required'),
  LastName: Yup.string().required('Last name is required'),
  Email: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter a valid email address'),
  DisplayName: Yup.string().required('Display name is required'),
  Phone: Yup.string().when('AccountType', {
    is: 'IndividualFamily',
    then: Yup.string().optional(),
    otherwise: Yup.string()
      .required('A contact number is required')
      .test(v => /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(v!))
  }),
  PlanterHidden: Yup.string().required(),
  FunderHidden: Yup.string().required(),
  PlanterName: Yup.string().when(['PlanterHidden', 'AccountActionType'], {
    is: (PlanterHidden: string, aat: AccountActionType) =>
      PlanterHidden === 'Private' || aat === AccountActionType.Donate,
    then: Yup.string().nullable(),
    otherwise: Yup.string().required()
  }),
  FunderName: Yup.string().when(['FunderHidden', 'AccountActionType'], {
    is: (FunderHidden: string, aat: AccountActionType) =>
      FunderHidden === 'Private' || aat === AccountActionType.Donate,
    then: Yup.string().nullable(),
    otherwise: Yup.string().required()
  }),
  BusinessSize: Yup.string().when('AccountType', {
    is: (accountType: AccountType) => accountType === AccountType.Business,
    then: Yup.string().required('Please select your business size'),
    otherwise: Yup.string().optional().nullable()
  }),
  PrimaryGoal: Yup.string().when('AccountActionType', {
    is: AccountActionType.Donate,
    then: Yup.string().required("Please tell us how you'd like to take action"),
    otherwise: Yup.string().optional().nullable()
  }),
  PrimaryGoalNote: Yup.string().optional().nullable(),
  Department: Yup.string().when(['AccountType', 'AccountActionType'], {
    is: (accountType: AccountType, accountActionType: AccountActionType) =>
      accountType === AccountType.Business &&
      accountActionType === AccountActionType.Donate,
    then: Yup.string().required('Please select your department'),
    otherwise: Yup.string().optional().nullable()
  }),
  JobTitle: Yup.string().when(['AccountType', 'AccountActionType'], {
    is: (accountType: AccountType, accountActionType: AccountActionType) =>
      accountType === AccountType.Business &&
      accountActionType === AccountActionType.Donate,
    then: Yup.string().required('Please enter your job title'),
    otherwise: Yup.string().optional().nullable()
  })
})
